"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const activeLoanDetails_1 = __importDefault(require("../../components/activeLoanDetails/activeLoanDetails"));
const loanStyles_1 = __importDefault(require("../loan/loanStyles"));
const text_1 = __importStar(require("../../components/text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const HomeLoan = ({ message = null, activeLoan }) => (react_1.default.createElement(react_native_1.View, null,
    message ? (react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_PRIMARY }, message))) : null,
    react_1.default.createElement(react_native_1.View, { style: [loanStyles_1.default.boxContainer, { paddingHorizontal: 10 }] },
        react_1.default.createElement(activeLoanDetails_1.default, { activeLoan: activeLoan }))));
HomeLoan.defaultProps = {
    message: null,
};
exports.default = HomeLoan;
